import React from 'react';
import styles from './CallTimer.module.css';

interface CallTimerProps {
  formattedTime: string;
  isWarning: boolean;
}

export const CallTimer: React.FC<CallTimerProps> = ({ formattedTime, isWarning }) => {
  return (
    <div 
      className={`${styles.timer} ${isWarning ? styles.warning : ''}`}
      role="timer"
      aria-live="polite"
      aria-atomic="true"
      aria-label={`Call duration ${formattedTime}${isWarning ? ', call ending soon' : ''}`}
    >
      <span className={styles.label}>Call Duration</span>
      <span className={styles.time}>{formattedTime}</span>
    </div>
  );
};
